/** Extrait un numéro FR plausible (mobile ou fixe) d'un texte libre. */
export function extractPhone(text: string): string {
  const m = text.match(/(?:\+33\s?|0)[1-9](?:[\s.-]?\d{2}){4}/);
  return m ? m[0].replace(/[\s.-]/g, "") : "";
}
